import createCrudModule from 'vuex-crud';

export default createCrudModule({
  resource: 'branches',
  urlRoot: 'public/branches',
  only: [
    'FETCH_LIST',
  ],
  parseList(response) {
    const { data } = response;

    return Object.assign({}, response, {
      data: data.data, // expecting array of objects with IDs
    });
  },

  onReplaceSuccess(state, response, xx) {
    // console.log(xx);
    // dispatch('crud/SET_SNACKBAR');
  },
  onCreateSuccess(state, response) {
    const { data } = response;
    const id = data.id.toString();

    const listIndex = state.list.indexOf(id);
    if (listIndex < 0) {
      state.list.push(id);
    }
  },
});
